class removeDiscountOnNewSession {
	constructor() {
		this.storageKey = 'hasClearedDiscount';
		this.init();
	}

	init() {
		if (!this.checkStorageValue()) {
			this.clearDiscount();
			this.setStorageValue();
		}
	}

	checkStorageValue() {
		return sessionStorage.getItem(this.storageKey) !== null;
	}
	setStorageValue() {
		sessionStorage.setItem(this.storageKey, 'true');
	}

	clearDiscount() {
		console.log('Clearing discount...');

		fetch(`/discount/clear`)
			.then(() => {
				console.log('Discount cleared successfully.');

				return fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						updates: {},
					}),
				});
			})
			.then(() => {
				console.log('Discount cleared successfully.');
			})
			.catch(error => {
				console.error('Error clearing discount:', error);
			});
	}
}

new removeDiscountOnNewSession();
